<template>
  <gj-modal
    v-bind="$attrs"
    v-on="$listeners"
    size="normal"
    :visible.sync="modalVisible"
    :no-padding="true"
    @cancel="cancel"
    @confirm="confirm"
  >
    <template #header>
      <span>重算</span>
    </template>
    <template #content>
      <div v-loading="loading" class="form-content">
        <el-form ref="form" :model="formData" :rules="rules">
          <el-form-item label="店铺：" prop="warehouseId">
            <gj-market-select
              multiple
              v-model="formData.warehouseId"
              :clearable="false"
              width="220px"
          ></gj-market-select>
          </el-form-item>
          <el-form-item label="重算时间区间：" prop="date">
            <gj-date-picker
              type="daterange"
              v-model="formData.date"
              width="220px"
              :clearable="false"
              :maxDayLength="180"
            ></gj-date-picker>
          </el-form-item>
        </el-form>
      </div>
    </template>
  </gj-modal>
</template>

<script>
// import { SELECT_WAREHOUSE } from "../config";
import { modalMixIn, queryMixin, selectionMixin } from "@/minxins";
import { storageCostBatchRecalculate, storageCostBatchWarehouseInitDate } from "@/api/finance";
import { convertToDate } from "@/utils/date.util.js"
export default {
  name: "Recalculation",
  mixins: [modalMixIn, queryMixin, selectionMixin],
  props: {},
  async created() {
    // this.warehouses = await SELECT_WAREHOUSE(true)
  },
  data() {
    return {
      loading: false,
      warehouses: [],
      formData: {
        warehouseId: null,
        date: "",
      },
      rules: {
        warehouseId: [
          { required: true, message: "请选择店铺", trigger: "blur" },
        ],
        date: [{ required: true, message: "请选择日期", trigger: "blur" }],
      },
      disabledDate: (time) => {
        let date = convertToDate(time)
        if (new Date(date).getTime() > new Date().getTime()) {// 限制今天以后
          return true
        }
        // if (this.minDate && new Date(date).getTime() < new Date(this.minDate).getTime()) {// 限制最小输入时间
        //   return true
        // }
        return false
      },
      minDate: ""
    };
  },
  methods: {
    input() {
      this.formData.date = ""
      this.storageCostBatchWarehouseInitDate()
    },
    // 获取店铺可选最小时间
    async storageCostBatchWarehouseInitDate() {
      this.loading = true
      try {
        let res = await storageCostBatchWarehouseInitDate(this.formData.warehouseId)
        this.minDate = convertToDate(res)
      } finally {
        this.loading = false
      }
    },
    // 确定
    confirm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.storageCostBatchRecalculate()
        } else {
          this.$gjMessage.error("请完善数据");
          return false;
        }
      });
    },
    //取消
    cancel() {
        this.$gjDestroy();
    },
    // 重算
    storageCostBatchRecalculate() {
      let params = {
        warehouseId: this.formData.warehouseId,
        recalculateDate: convertToDate(this.formData.date)
      }
      storageCostBatchRecalculate(params)
      this.$gjMessage.success('操作成功，系统正在重算，请稍后查看数据');
      this.$gjDestroy();
    }
  },
};
</script>

<style scoped lang="scss">
.form-content {
  padding-top: 20px;
}
/deep/.el-dialog__body{
  display: inline-block;
}
/deep/.el-form-item {
  margin-bottom: 20px;
}
/deep/.el-form-item__label {
  width: 186px;
}
/deep/.el-form-item__error {
  left: 123px;
}
.alert-title {
  padding-bottom: 3px;
}
</style>
